// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IE5R","top":"styles_top__3CvXi","left":"styles_left__2N39M","description":"styles_description__3JLC_"};